import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=bc464d9a&scoped=true"
import script from "./bank.vue?vue&type=script&lang=js"
export * from "./bank.vue?vue&type=script&lang=js"
import style0 from "./bank.vue?vue&type=style&index=0&id=bc464d9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc464d9a",
  null
  
)

export default component.exports